<template>
  <v-card-title>
    <div>
      <div class="item-title">{{ value.name }}</div>
      <span>{{ value.description }}</span><br>
      <template v-if="!value.priceVariations">
        <span class="item-price">{{ value.price | currency }}</span>
      </template>
      <template v-else>
        <span class="item-price">{{ value.priceTable[0].price | currency }}</span><span v-if="value.priceTable.length > 1"> e mais {{ value.priceTable.length - 1 }}...</span>
      </template>
    </div>
  </v-card-title>
</template>

<script>
export default {
  name: 'item-title',
  props: ['value'],
  filters: {
    currency (value) {
      let newValue = 0
      if (typeof value !== 'number') {
        newValue = parseFloat(value.replace('.', '').replace(',', '.'))
      } else if (typeof value === 'number') {
        newValue = value
      } else {
        return ''
      }
      return newValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    }
  }
}
</script>
<style>
.item-title{
  font-weight: 600;
  font-size: 20px;
  margin-bottom: 5px;
}
.item-price{
  color: #129066;
  font-size: 26px;
}
.item-multi-price .item-price{
  color: #129066;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// Title.vue?3018bb04